import { LoadingSpinner } from '../loading-spinner/loading-spinner';
import { StyledLoadingPlaceHolder } from './loading-place-holder.styles';

export const LoadingPlaceHolder = () => {
    return (
        <StyledLoadingPlaceHolder>
            <LoadingSpinner />
        </StyledLoadingPlaceHolder>
    );
};